import React from 'react';
import { useSelector } from 'react-redux';
import FilterContainer from '@src/components/overview-dashboard/filter';
import DatePicker from '@src/components/overview-dashboard/overview-date-picker';
import KebabDropDown from '@src/components/overview-dashboard/kebab-dropdown';
import OverviewExportOption from '@src/components/overview-dashboard/ExportOption';
import LatchShare from '@src/components/overview-dashboard/LatchShare';
import PopShare from '@src/components/share/PopShare';
import { overviewShareConfig } from '@src/components/share/utils';
import commonSelector from '@store/common/selectors';
import featureNames from '@utils/featureToggle/constants';
import { PAGE_TYPE } from '@utils/constants';
import { SummaryWrapper, RightTopBarWrapper } from '../styled';

const { baseUrl } = window.conviva;

// eslint-disable-next-line react/display-name
export default ({ currentShareId, pageType }) => {
  const { features } = useSelector(commonSelector);
  const isOverviewShareEnabled = features[featureNames.OVB_SHARE];

  const showShareOption = isOverviewShareEnabled && pageType !== PAGE_TYPE.SHARING;
  const shareConfig = {
    ...overviewShareConfig,
    url: `${baseUrl}/dashboard/overview/sharing`,
  };

  return (
    <SummaryWrapper>
      <LatchShare />
      <FilterContainer />
      <RightTopBarWrapper>
        <DatePicker />
        {showShareOption && <PopShare config={shareConfig} />}
        <OverviewExportOption pageType={pageType} />
        <KebabDropDown currentShareId={currentShareId} pageType={pageType} />
      </RightTopBarWrapper>
    </SummaryWrapper>
  );
};
